import { Component, OnInit } from '@angular/core';
import { MasterDataService } from 'src/app/services/master-data.service';
import { MydiaryService } from 'src/app/services/mydiary.service';

@Component({
  selector: 'app-all-partners-dashboard',
  templateUrl: './all-partners-dashboard.component.html',
  styleUrls: ['./all-partners-dashboard.component.css']
})
export class AllPartnersDashboardComponent implements OnInit {

  contributionsList=[];
  currentContributionsList=[];
  previousContributionsList=[];
  partnerHeadcountList=[];
  partnerAssetCountList=[];

 
  userName;
  announcementCount;
  leaveBalanceCount;
  penaltyCharged;
  penaltyUncharged;
  penaltyChargedTeam;
  penaltyUnchargedTeam;
  pendingDiariesWeekCount;
  pendingDiariesWeekTeam;
  pendingDiaryApprovalTeam;
  pendingDiaryApproval;
  unapprovedTsheetAmount;
  pendingTsheetApproval;
  employeePuneCount;
  articlePuneCount;
  consultantPuneCount;
  employeeFirmCount;
  articleFirmCount;
  consultantFirmCount;
  probationCount;
  articleshipEndCount;
  consultantEndCount;
  articleVaccancyCount;
  incompleteProfileCount;
  laptopAssetPuneCount;
  assignedAssetPuneCount;
  instockAssetPuneCount;
  laptopAssetFirmCount;
  assignedAssetFirmCount;
  instockAssetFirmCount;
  userRole;
  overtimePaid;
  overtimePaidPy;
  checkHRRole:boolean;
  checkPartnerRole:boolean;
  contributionCYFees;
  contributionPercentage;
contributionCYBudgetedCost;
contributionCYActualCost;
contributionCYBudgetedContri;
contributionCYActualContri;
contributionCYPercentage;
contributionPYPercentage;
budgetedContributionCYPercentage;
budgetedContributionPYPercentage;
actualFees;
contributionPYFees;
contributionPYActualFees;
contributionPYBudgetedCost;
contributionPYActualCost;
contributionPYBudgetedContri;
contributionPYActualContri;
totalClientsCY;
totalAssignmentsCY;
totalClientsPY;
totalAssignmentsPY;
approverList;
branchName;
userId;
checkApproverforRoute:Boolean;
CY;
PY;
currentFinancialYear;
manDaysClientsCY;
mandaysPgbCY;
manDaysClientsPY;
mandaysPgbPY;
partnerId;
showDashboard=false;
excludePartnerFlag=false;
HrRoleActive:Boolean;
totalActualContribution;
totalActualContributionPercentage;
totalActualCost;
totalActualFees;
totalBudgetedContribution;
totalBudgetedContributionPercentage;
totalBudgetedCost;
totalBudgetedFees;

totalBudgetedFeesCy;
totalBudgetedCostCy;
totalBudgetedContributionPercentageCy;
totalActualFeesCy;
totalActualCostCy;
totalActualContributionPercentageCy;

totalBudgetedFeesPy;
totalBudgetedCostPy;
totalBudgetedContributionPercentagePy;
totalActualFeesPy;
totalActualCostPy;
totalActualContributionPercentagePy;


headCountObj={ Firm: { employee :0 ,article: 0, consultant: 0},
 Pune:{ employee :0 ,article: 0, consultant: 0},
 Mumbai:{ employee :0 ,article: 0, consultant: 0},
 Belgaum:{ employee :0 ,article: 0, consultant: 0},
 Dharwad:{ employee :0 ,article: 0, consultant: 0},
 Kolhapur:{ employee :0 ,article: 0, consultant: 0}};

 assetCountObj={ Firm: { laptops :0 ,assigned: 0, instock: 0},
 Pune:{ laptops :0 ,assigned: 0, instock: 0},
 Mumbai:{ laptops :0 ,assigned: 0, instock: 0},
 Belgaum:{ laptops :0 ,assigned: 0, instock: 0},
 Dharwad:{ laptops :0 ,assigned: 0, instock: 0},
 Kolhapur:{ laptops :0 ,assigned: 0, instock: 0}};

 dashboardFinancials={ opening:0, contributionPercent:0,billsRaised:0,billsGreaterSixMonths:0,
  receipt:0,badDebts:0,closing:0,creditNotes:0,employeeCost:0,reimbursement:0,contribution:0

 };


 
 currentYearMis= {
   "financialYear": "",
   "dashboardFinancialsRest": {
       "opening": 0,
       "billsRaised": 0,
       "receipt": 0,
       "closing": 0,
       "employeeCost": 0,
       "contribution": 0,
       "contributionPercent": 0.0,
       "billsGreaterSixMonths": 0,
       "badDebts": 0,
       "creditNotes": 0,
       "reimbursement": 0
   },
   "dashboardBusinessRest": {
       "newClientsFees": 0,
       "newAssignmentsFees": 0,
       "feesRise": 0,
       "discontinuedFees": 0,
       "netAddition": 0,
       "potentialClientsFees": 0
   },
   "misTrainingReportRest": {
       "quarter": null,
       "partner": null,
       "pgbPresenterRequired": 0,
       "pgbInternelRequired": 0,
       "cpeRequired": 0,
       "pgbPresenterActual": 0,
       "pgbInternelActual": 0,
       "cpeActual": 0,
       "pgbPresenterBalance": 0,
       "pgbInternelBalance": 0,
       "cpeBalance": 0
   }
 }
 
 previousYearMis={
   "financialYear": "",
   "dashboardFinancialsRest": {
       "opening": 0,
       "billsRaised": 0,
       "receipt": 0,
       "closing": 0,
       "employeeCost": 0,
       "contribution": 0,
       "contributionPercent": 0.0,
       "billsGreaterSixMonths": 0,
       "badDebts": 0,
       "creditNotes": 0,
       "reimbursement": 0
   },
   "dashboardBusinessRest": {
       "newClientsFees": 0,
       "newAssignmentsFees": 0,
       "feesRise": 0,
       "discontinuedFees": 0,
       "netAddition": 0,
       "potentialClientsFees": 0
   },
   "misTrainingReportRest": {
       "quarter": null,
       "partner": null,
       "pgbPresenterRequired": 0,
       "pgbInternelRequired": 0,
       "cpeRequired": 0,
       "pgbPresenterActual": 0,
       "pgbInternelActual": 0,
       "cpeActual": 0,
       "pgbPresenterBalance": 0,
       "pgbInternelBalance": 0,
       "cpeBalance": 0
   }
 }
 

 partnersDashboardLeave={
  "taken": 0,
  "balance": 0,
  "toApprove": 0
};

balanceTraining={
  "id": 0,
  "pgbPresenter": 0,
  "pgbInternal": 0,
  "cpe": 0
};

partnersPenaltyList=[{
  "id": 0,
  "name": "",
  "charged": 0,
  "unCharged": 0
}];

partnersPendingDeclarationList=[{
  
    "id": 0,
    "name": "",
    "declarationsCount": 0,
    "delayInDays": 0
}
]

 dashboardBusiness={ newClientsFees:0, newAssignmentsFees:0,feesRise:0,discontinuedFees:0,
  netAddition:0,potentialClientsFees:0}

  partnerAssignmentAndMandaysList=[{
    "name": "",
    "assignmentAndMandaysDtos": [
      {
        "year": "",
        "totalClients": 0,
        "totalAssignments": 0,
        "mandaysClients": 0,
        "mandaysPGB": 0
      },
      {
        "year": "",
        "totalClients": 0,
        "totalAssignments": 0,
        "mandaysClients": 0,
        "mandaysPGB": 0
      }
    ]
  }];

  

 
  constructor(private masterDataService:MasterDataService, private myDiaryService:MydiaryService) { }

  ngOnInit(): void {
   //  this.CY='2024-2025';
   //  this.PY='2023-2024'
  this.userRole=localStorage.getItem('userRole');

  this.currentFinancialYear = this.calculateFinancialYear();

  console.log('userRole',this.userRole);
  if(this.userRole=='HR Assistant' || this.userRole=='HR Executive' || this.userRole=='HR Manager'){
   this.checkHRRole=true;
   this.HrRoleActive=true;
  //this.getHRAdminCount();
  }else if(['Partner', 'Managing Partner', 'Designated Partner'].includes(this.userRole)){
  this.checkPartnerRole=true;
  this.checkHRRole=true;
  this.HrRoleActive=false;
  this.getManagingPartnerDetails();
  
  //this.getPartnerCount();
 // this.getHRAdminCount();

  }else{
    this.checkHRRole=false;
    this.checkPartnerRole=false;
    this.HrRoleActive=false;
  }

  this.userId=localStorage.getItem('id');
  if(['Partner', 'Managing Partner', 'Designated Partner'].includes(this.userRole) && (this.userId==52 || this.userId==1074 || this.userId==51 || this.userId==53))
  {
    this.showDashboard=true;
  }
  else{
    this.showDashboard=false;
   }

   if( this.userRole=='HR Assistant' || this.userRole=='HR Executive' || this.userRole=='HR Manager' || this.userRole=='Article'  )
   {
        this.excludePartnerFlag=true;
   }
   else{
    this.excludePartnerFlag=false;
   }


   console.log('show dashboard',this.showDashboard)
  
//   this.myDiaryService.getApprovers().subscribe((resp:any)=>{
//   console.log('approver list in dashboard',resp);
//   this.approverList=resp;
//   this.approverList.map((data:any)=>{
//     if(data.id==this.userId){
//       this.checkApproverforRoute=true;
//       console.log('checkApproverforRoute',this.checkApproverforRoute)
//     }
//     // else{
//     //   this.checkApproverforRoute=false;
//     //   console.log('checkApproverforRoute else',this.checkApproverforRoute)

//     // }
//   })
// });

  this.userName=localStorage.getItem('userFname') +' '+localStorage.getItem('userLname');
   //this.getDashboardCount();
  }

  getDashboardCount(){
    
this.masterDataService.getCommonDashboardDetails().subscribe((resp:any)=>{
  console.log('common detaildashboard', resp);
 this.announcementCount=resp.announcementCount;
 this.leaveBalanceCount=resp.leaveBalanceCount;
 this.pendingDiariesWeekCount=resp.pendingDiariesWeekCount;
 this.pendingDiaryApproval=resp.pendingDiaryApproval;
 this.pendingDiaryApprovalTeam=resp.pendingDiaryApprovalTeam;
 this.pendingDiariesWeekTeam=resp.pendingDiariesWeekTeam;
 this.unapprovedTsheetAmount=resp.unapprovedTsheetAmount;
 this.pendingTsheetApproval=resp.pendingTsheetApproval;
 this.penaltyCharged=resp.penaltyCharged;
 this.penaltyUncharged=resp.penaltyUncharged;
 this.penaltyChargedTeam=resp.penaltyChargedTeam;
 this.penaltyUnchargedTeam=resp.penaltyUnchargedTeam;
 this.partnersDashboardLeave=resp.partnersDashboardLeaveDto;
 
 

//  resp.mandays.map((data:any)=>{
//   if(this.CY==data.year){
//     this.manDaysClientsCY=data.mandaysClients;
//     this.mandaysPgbCY=data.mandaysPgb;
//   }else{
//     this.manDaysClientsPY=data.mandaysClients;
//     this.mandaysPgbPY=data.mandaysPgb;
//   }
// })
});



  }


  calculateFinancialYear() {
   const today = new Date();
   const currentYear = today.getFullYear();
   const nextYear = currentYear + 1;
   const financialYear = `${currentYear}-${nextYear.toString().slice(2)}`;
   return financialYear;
 }


  getManagingPartnerDetails()
  {
      this.masterDataService.getManagingPartnerDashboardDetails().subscribe((resp:any)=>{
        console.log('managing partner details',resp);
        this.overtimePaid=resp.overtimePaid;
      this.overtimePaidPy=resp.overtimePaidPy;
      this.CY=resp.currentFY;
      this.PY=resp.previousFY;
      //this.contributionsList=resp.contributions;
     // this.dashboardBusiness=resp.dashboardBusinessRest;
      this.partnerAssignmentAndMandaysList=resp.partnersAssignmentAndMandaysDto;
      this.contributionPercentage=resp.contributionBellow35Percent;
      //this.dashboardFinancials=resp.dashboardFinancialsRest;  
      this.partnerHeadcountList=resp.partnerHeadcountRests;
      this.partnerAssetCountList=resp.partnerAssetCountRest;
      this.partnersPenaltyList=resp.partnersPenaltyRests; 
      this.partnersPendingDeclarationList=resp.partnersPendingDeclarationRests;
      this.totalActualContribution=resp.totalActualContribution;
      this.totalActualContributionPercentage=resp.totalActualContributionPercentage;
      this.totalActualCost=resp.totalActualCost;
      this.totalActualFees=resp.totalActualFees;
      this.totalBudgetedContribution=resp.totalBudgetedContribution;
      this.totalBudgetedContributionPercentage=resp.totalBudgetedContributionPercentage;
      this.totalBudgetedCost=resp.totalBudgetedCost;
      this.totalBudgetedFees=resp.totalBudgetedFees;

      this.totalBudgetedFeesCy=resp.totalBudgetedFeesCy;
      this.totalBudgetedCostCy=resp.totalBudgetedCostCy;
      this.totalBudgetedContributionPercentageCy=resp.totalBudgetedContributionPercentageCy;
      this.totalActualFeesCy=resp.totalActualFeesCy;
      this.totalActualCostCy=resp.totalActualCostCy;
      this.totalActualContributionPercentageCy=resp.totalActualContributionPercentageCy;

      this.totalBudgetedFeesPy=resp.totalBudgetedFeesPy;
      this.totalBudgetedCostPy=resp.totalBudgetedCostPy;
      this.totalBudgetedContributionPercentagePy=resp.totalBudgetedContributionPercentagePy;
      this.totalActualFeesPy=resp.totalActualFeesPy;
      this.totalActualCostPy=resp.totalActualCostPy;
      this.totalActualContributionPercentagePy=resp.totalActualContributionPercentagePy;

      for (let i = 0; i < resp.dashboardMisRests.length; i++) {
         // Access each object in the array using index 'i'
        if(this.CY==resp.dashboardMisRests[i].financialYear)
         {
           this.currentYearMis=resp.dashboardMisRests[i];
         }else{
           this.previousYearMis=resp.dashboardMisRests[i];
         }
         
     }
      
     for(let j=0;j < resp.contributions.length;j++)
     {
         if(this.CY==resp.contributions[j].year)
         {
           this.currentContributionsList.push(resp.contributions[j])
         }
         else if(this.PY==resp.contributions[j].year)
         {
            this.previousContributionsList.push(resp.contributions[j])
         }
     }

console.log('currentContributionsList',this.currentContributionsList);
console.log('previousContributionsList',this.previousContributionsList);


      console.log('penallty!!',this.partnersPenaltyList);
      if(resp.balanceTrainingRest!=null)
      {
        this.balanceTraining=resp.balanceTrainingRest;
      }
      console.log('mandays',this.partnerAssignmentAndMandaysList);

      for (const item of resp.partnerHeadcountRests) {
          
             for(const detail of item.headCountDto)
            {
                if(detail.branch=="Pune" && detail.type=="Employee")
                {
                   this.headCountObj.Pune.employee=detail.count
                }
                if(detail.branch=="Pune" && detail.type=="Consultant")
                {
                   this.headCountObj.Pune.consultant=detail.count
                }
                if(detail.branch=="Pune" && detail.type=="Article")
                {
                   this.headCountObj.Pune.article=detail.count
                }

                if(detail.branch=="Firm" && detail.type=="Employee")
                {
                   this.headCountObj.Firm.employee=detail.count
                }
                if(detail.branch=="Firm" && detail.type=="Consultant")
                {
                   this.headCountObj.Firm.consultant=detail.count
                }
                if(detail.branch=="Firm" && detail.type=="Article")
                {
                   this.headCountObj.Firm.article=detail.count
                }

                if(detail.branch=="Mumbai" && detail.type=="Employee")
                {
                   this.headCountObj.Mumbai.employee=detail.count
                }
                if(detail.branch=="Mumbai" && detail.type=="Consultant")
                {
                   this.headCountObj.Mumbai.consultant=detail.count
                }
                if(detail.branch=="Mumbai" && detail.type=="Article")
                {
                   this.headCountObj.Mumbai.article=detail.count
                }

                if(detail.branch=="Belgaum" && detail.type=="Employee")
                {
                   this.headCountObj.Belgaum.employee=detail.count
                }
                if(detail.branch=="Belgaum" && detail.type=="Consultant")
                {
                   this.headCountObj.Belgaum.consultant=detail.count
                }
                if(detail.branch=="Belgaum" && detail.type=="Article")
                {
                   this.headCountObj.Belgaum.article=detail.count
                }

                if(detail.branch=="Kolhapur" && detail.type=="Employee")
                {
                   this.headCountObj.Kolhapur.employee=detail.count
                }
                if(detail.branch=="Kolhapur" && detail.type=="Consultant")
                {
                   this.headCountObj.Kolhapur.consultant=detail.count
                }
                if(detail.branch=="Kolhapur" && detail.type=="Article")
                {
                   this.headCountObj.Kolhapur.article=detail.count
                }

                if(detail.branch=="Dharwad-Hubli" && detail.type=="Employee")
                {
                   this.headCountObj.Dharwad.employee=detail.count
                }
                if(detail.branch=="Dharwad-Hubli" && detail.type=="Consultant")
                {
                   this.headCountObj.Dharwad.consultant=detail.count
                }
                if(detail.branch=="Dharwad-Hubli" && detail.type=="Article")
                {
                   this.headCountObj.Dharwad.article=detail.count
                }
            }


          }
        
          for (const item of resp.partnerAssetCountRest) {
          
            for(const detail of item.assetCountDto)
           {
               if(detail.branch=="Pune")
               {
                  this.assetCountObj.Pune.laptops=detail.laptops
                  this.assetCountObj.Pune.assigned=detail.assigned
                  this.assetCountObj.Pune.instock=detail.instock
               }
               if(detail.branch=="Firm")
               {
                  this.assetCountObj.Firm.laptops=detail.laptops
                  this.assetCountObj.Firm.assigned=detail.assigned
                  this.assetCountObj.Firm.instock=detail.instock
               }
               if(detail.branch=="Mumbai")
               {
                  this.assetCountObj.Mumbai.laptops=detail.laptops
                  this.assetCountObj.Mumbai.assigned=detail.assigned
                  this.assetCountObj.Mumbai.instock=detail.instock
               }
               if(detail.branch=="Dharwad-Hubli")
               {
                  this.assetCountObj.Dharwad.laptops=detail.laptops
                  this.assetCountObj.Dharwad.assigned=detail.assigned
                  this.assetCountObj.Dharwad.instock=detail.instock
               }
               if(detail.branch=="Belgaum")
               {
                  this.assetCountObj.Belgaum.laptops=detail.laptops
                  this.assetCountObj.Belgaum.assigned=detail.assigned
                  this.assetCountObj.Belgaum.instock=detail.instock
               }
               if(detail.branch=="Kolhapur")
               {
                  this.assetCountObj.Kolhapur.laptops=detail.laptops
                  this.assetCountObj.Kolhapur.assigned=detail.assigned
                  this.assetCountObj.Kolhapur.instock=detail.instock
               }
               
           }


         }
      
      console.log('headCount',this.headCountObj);
      console.log('assetCount',this.assetCountObj);
    
      
     
      resp.contributions.map((data:any)=>{
        if(this.CY==data.year){
        this.contributionCYFees=data.fees;
        this.actualFees=data.actualFees;
        this.contributionCYBudgetedCost=data.budgetedCost;
        this.contributionCYActualCost=data.actualCost;
        this.contributionCYBudgetedContri=data.budgetedContribution;
        this.contributionCYActualContri=data.actualContribution
        this.contributionCYPercentage=data.actualContributionPercentage
        this.budgetedContributionCYPercentage=data.budgetedContributionPercentage;
        }else{
          this.contributionPYFees=data.fees;
          this.contributionPYActualFees=data.actualFees
          this.contributionPYBudgetedCost=data.budgetedCost;
          this.contributionPYActualCost=data.actualCost;
          this.contributionPYBudgetedContri=data.budgetedContribution;
          this.contributionPYActualContri=data.actualContribution
          this.contributionPYPercentage=data.actualContributionPercentage;
          this.budgetedContributionPYPercentage=data.budgetedContributionPercentage;
        }
      })

      // resp.clientsAndAssignments.map((data:any)=>{
      //   if(this.CY==data.year){
      //     this.totalClientsCY=data.totalClients;
      //     this.totalAssignmentsCY=data.totalAssignments;
      //   }else{
      //     this.totalClientsPY=data.totalClients;
      //     this.totalAssignmentsPY=data.totalAssignments;
      //   }
      // })
      })
  }

  getPartnerCount(){

    this.masterDataService.getPartnerDashboardDetails().subscribe((resp:any)=>{
      console.log('partner details',resp);
      this.overtimePaid=resp.overtimePaid;
      this.overtimePaidPy=resp.overtimePaidPy;
      //this.contributionsList=resp.contributions;
      //this.dashboardBusiness=resp.dashboardBusinessRest;
      this.partnerAssignmentAndMandaysList=resp.partnersAssignmentAndMandaysDto;
      this.contributionPercentage=resp.contributionBellow35Percent;
      //this.dashboardFinancials=resp.dashboardFinancialsRest;  
      //this.partnerHeadcountList=resp.partnerHeadcountRests;
      this.partnerAssetCountList=resp.partnerAssetCountRest;
      if(resp.balanceTrainingRest!=null)
      {
        this.balanceTraining=resp.balanceTrainingRest;
      }
      console.log('mandays',this.partnerAssignmentAndMandaysList);

      // for (const item of resp.partnerHeadcountRests) {
          
      //        for(const detail of item.headCountDto)
      //       {
      //           if(detail.branch=="Pune" && detail.type=="Employee")
      //           {
      //              this.headCountObj.Pune.employee=detail.count
      //           }
      //           if(detail.branch=="Pune" && detail.type=="Consultant")
      //           {
      //              this.headCountObj.Pune.consultant=detail.count
      //           }
      //           if(detail.branch=="Pune" && detail.type=="Article")
      //           {
      //              this.headCountObj.Pune.article=detail.count
      //           }

      //           if(detail.branch=="Firm" && detail.type=="Employee")
      //           {
      //              this.headCountObj.Firm.employee=detail.count
      //           }
      //           if(detail.branch=="Firm" && detail.type=="Consultant")
      //           {
      //              this.headCountObj.Firm.consultant=detail.count
      //           }
      //           if(detail.branch=="Firm" && detail.type=="Article")
      //           {
      //              this.headCountObj.Firm.article=detail.count
      //           }

      //           if(detail.branch=="Mumbai" && detail.type=="Employee")
      //           {
      //              this.headCountObj.Mumbai.employee=detail.count
      //           }
      //           if(detail.branch=="Mumbai" && detail.type=="Consultant")
      //           {
      //              this.headCountObj.Mumbai.consultant=detail.count
      //           }
      //           if(detail.branch=="Mumbai" && detail.type=="Article")
      //           {
      //              this.headCountObj.Mumbai.article=detail.count
      //           }

      //           if(detail.branch=="Belgaum" && detail.type=="Employee")
      //           {
      //              this.headCountObj.Belgaum.employee=detail.count
      //           }
      //           if(detail.branch=="Belgaum" && detail.type=="Consultant")
      //           {
      //              this.headCountObj.Belgaum.consultant=detail.count
      //           }
      //           if(detail.branch=="Belgaum" && detail.type=="Article")
      //           {
      //              this.headCountObj.Belgaum.article=detail.count
      //           }

      //           if(detail.branch=="Kolhapur" && detail.type=="Employee")
      //           {
      //              this.headCountObj.Kolhapur.employee=detail.count
      //           }
      //           if(detail.branch=="Kolhapur" && detail.type=="Consultant")
      //           {
      //              this.headCountObj.Kolhapur.consultant=detail.count
      //           }
      //           if(detail.branch=="Kolhapur" && detail.type=="Article")
      //           {
      //              this.headCountObj.Kolhapur.article=detail.count
      //           }

      //           if(detail.branch=="Dharwad-Hubli" && detail.type=="Employee")
      //           {
      //              this.headCountObj.Dharwad.employee=detail.count
      //           }
      //           if(detail.branch=="Dharwad-Hubli" && detail.type=="Consultant")
      //           {
      //              this.headCountObj.Dharwad.consultant=detail.count
      //           }
      //           if(detail.branch=="Dharwad-Hubli" && detail.type=="Article")
      //           {
      //              this.headCountObj.Dharwad.article=detail.count
      //           }
      //       }


      //     }
        
         //  for (const item of resp.partnerAssetCountRest) {
          
         //    for(const detail of item.assetCountDto)
         //   {
         //       if(detail.branch=="Pune")
         //       {
         //          this.assetCountObj.Pune.laptops=detail.laptops
         //          this.assetCountObj.Pune.assigned=detail.assigned
         //          this.assetCountObj.Pune.instock=detail.instock
         //       }
         //       if(detail.branch=="Firm")
         //       {
         //          this.assetCountObj.Firm.laptops=detail.laptops
         //          this.assetCountObj.Firm.assigned=detail.assigned
         //          this.assetCountObj.Firm.instock=detail.instock
         //       }
         //       if(detail.branch=="Mumbai")
         //       {
         //          this.assetCountObj.Mumbai.laptops=detail.laptops
         //          this.assetCountObj.Mumbai.assigned=detail.assigned
         //          this.assetCountObj.Mumbai.instock=detail.instock
         //       }
         //       if(detail.branch=="Dharwad-Hubli")
         //       {
         //          this.assetCountObj.Dharwad.laptops=detail.laptops
         //          this.assetCountObj.Dharwad.assigned=detail.assigned
         //          this.assetCountObj.Dharwad.instock=detail.instock
         //       }
         //       if(detail.branch=="Belgaum")
         //       {
         //          this.assetCountObj.Belgaum.laptops=detail.laptops
         //          this.assetCountObj.Belgaum.assigned=detail.assigned
         //          this.assetCountObj.Belgaum.instock=detail.instock
         //       }
         //       if(detail.branch=="Kolhapur")
         //       {
         //          this.assetCountObj.Kolhapur.laptops=detail.laptops
         //          this.assetCountObj.Kolhapur.assigned=detail.assigned
         //          this.assetCountObj.Kolhapur.instock=detail.instock
         //       }
               
         //   }


         // }
      
      console.log('headCount',this.headCountObj);
      console.log('assetCount',this.assetCountObj);
    
      
     
      resp.contributions.map((data:any)=>{
        if(this.CY==data.year){
        this.contributionCYFees=data.fees;
        this.actualFees=data.actualFees;
        this.contributionCYBudgetedCost=data.budgetedCost;
        this.contributionCYActualCost=data.actualCost;
        this.contributionCYBudgetedContri=data.budgetedContribution;
        this.contributionCYActualContri=data.actualContribution
        this.contributionCYPercentage=data.actualContributionPercentage
        this.budgetedContributionCYPercentage=data.budgetedContributionPercentage;
        }else{
          this.contributionPYFees=data.fees;
          this.contributionPYActualFees=data.actualFees
          this.contributionPYBudgetedCost=data.budgetedCost;
          this.contributionPYActualCost=data.actualCost;
          this.contributionPYBudgetedContri=data.budgetedContribution;
          this.contributionPYActualContri=data.actualContribution
          this.contributionPYPercentage=data.actualContributionPercentage;
          this.budgetedContributionPYPercentage=data.budgetedContributionPercentage;
        }
      })

      resp.clientsAndAssignments.map((data:any)=>{
        if(this.CY==data.year){
          this.totalClientsCY=data.totalClients;
          this.totalAssignmentsCY=data.totalAssignments;
        }else{
          this.totalClientsPY=data.totalClients;
          this.totalAssignmentsPY=data.totalAssignments;
        }
      })
      
    })

  }

getHRAdminCount(){
  this.masterDataService.getHRAdminDashboardDetails().subscribe((resp:any)=>{
    console.log('HR admin details',resp);
    this.branchName=resp.branch;
    resp.headCountBranch.map((data:any)=>{
      if(data.type=='Employee'){
        this.employeePuneCount=data.count;
      }else if(data.type=='Article'){
        this.articlePuneCount=data.count;
      }else{
      this.consultantPuneCount=data.count;
      }
    })

    resp.headCountFirm.map((data:any)=>{
      if(data.type=='Employee'){
        this.employeeFirmCount=data.count;
      }else if(data.type=='Article'){
        this.articleFirmCount =data.count;
      }else{
        console.log('consultant count',data.count);
      this.consultantFirmCount=data.count;
      }
    })

    this.probationCount=resp.reminders.probationCount;
    this.articleshipEndCount=resp.reminders.articleshipEndCount;
    this.consultantEndCount=resp.reminders.consultantsEndCount;
    this.articleVaccancyCount=resp.artcileVacancy;
    this.incompleteProfileCount=resp.incompleteProfiles;
 
    resp.assetsBranch.map((data:any)=>{
    this.laptopAssetPuneCount=data.laptops;
    this.assignedAssetPuneCount=data.assigned;
    this.instockAssetPuneCount=data.instock;
    })

    resp.assetsFirm.map((data:any)=>{
    this.laptopAssetFirmCount=data.laptops;
    this.assignedAssetFirmCount=data.assigned;
    this.instockAssetFirmCount=data.instock;
    })
  })
   } 

   getValidNumber(value: any): number {
  const num = Number(value);
  return isNaN(num) ? 0 : num;
}
}
